"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _topicHelpfulness = _interopRequireDefault(require("./topicHelpfulness"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _axios = _interopRequireDefault(require("axios"));

var _getTopicType = _interopRequireDefault(require("../../utils/getTopicType"));

var _config = require("../../libs/config");

var _Analytics = _interopRequireDefault(require("../analytics/Analytics"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'topic-helpfulness';
exports.cssAnchorName = cssAnchorName;

var TopicHelpfulnessContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicHelpfulnessContainer, _Component);

  var _super = _createSuper(TopicHelpfulnessContainer);

  function TopicHelpfulnessContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopicHelpfulnessContainer);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "oldScroll", void 0);
    _this.state = {
      value: null,
      isDismissed: false,
      isRemoved: false,
      isSticky: false,
      animationClass: null,
      visible: false,
      indicatorEnabled: false,
      helpfulnessPercentage: null,
      configurationLoaded: false
    };
    _this.setData = _this.setData.bind((0, _assertThisInitialized2.default)(_this));
    _this.hideWidget = _this.hideWidget.bind((0, _assertThisInitialized2.default)(_this));
    _this.onScroll = _this.onScroll.bind((0, _assertThisInitialized2.default)(_this));
    _this.getOldScroll = _this.getOldScroll.bind((0, _assertThisInitialized2.default)(_this));
    _this.oldScroll = _this.getOldScroll();
    return _this;
  }

  (0, _createClass2.default)(TopicHelpfulnessContainer, [{
    key: "getOldScroll",
    value: function getOldScroll() {
      if (typeof window === 'undefined') {
        return 0;
      }

      return window.scrollY || document.documentElement.scrollTop;
    }
  }, {
    key: "updateStorage",
    value: function updateStorage() {
      if (typeof window === 'undefined') return;
      var data = JSON.parse(window.localStorage.getItem('topicHelpfulness') || '{}');
      data[this.props.topic.id] = {
        value: this.state.value,
        isDismissed: this.state.isDismissed,
        isRemoved: this.state.isRemoved
      };
      window.localStorage.setItem('topicHelpfulness', JSON.stringify(data));
    }
  }, {
    key: "removeWidget",
    value: function removeWidget() {
      var _this2 = this;

      this.setState({
        isRemoved: true
      }, function () {
        return _this2.updateStorage();
      });
    }
  }, {
    key: "hideWidget",
    value: function hideWidget() {
      var _this3 = this;

      window.removeEventListener('scroll', this.onScroll);
      this.setState({
        animationClass: 'easy-out'
      });
      window.setTimeout(function () {
        _this3.setState({
          isDismissed: true,
          isSticky: false,
          animationClass: ''
        });
      }, 300);
    }
  }, {
    key: "setData",
    value: function () {
      var _setData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value) {
        var _this4 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  animationClass: 'fade-out'
                });
                window.setTimeout(function () {
                  _this4.setState({
                    value: value,
                    animationClass: ''
                  });

                  window.setTimeout(function () {
                    _this4.hideWidget();
                  }, 3000);
                }, 300);

                _Analytics.default.send('Topic helpfulness', _config.ratingDataMap.ga[value]);

                _publish.default.trackEvent('userevent', {
                  type: 'Topic Rated',
                  rating: _config.ratingDataMap.messagebus[value],
                  topic_title: this.props.topic.title,
                  topic_type: (0, _getTopicType.default)(this.props.topic.prefixId, this.props.topic.contentType),
                  topic_id: this.props.topic.id,
                  topic_url: window.location.origin + window.location.pathname,
                  topic_views: this.props.topic.views,
                  source: 'community'
                });

                _context.next = 6;
                return _axios.default.post(_config.CONTENT_HELPFULNESS_VOTE_URL, {
                  topic: this.props.topic.id,
                  vote: value
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setData(_x) {
        return _setData.apply(this, arguments);
      }

      return setData;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this5 = this;

      if (typeof window === 'undefined') return;
      var data = JSON.parse(window.localStorage.getItem('topicHelpfulness') || '{}');

      if (data[this.props.topic.id]) {
        var _data$this$props$topi = data[this.props.topic.id],
            value = _data$this$props$topi.value,
            isDismissed = _data$this$props$topi.isDismissed,
            isRemoved = _data$this$props$topi.isRemoved;

        if (!isRemoved) {
          this.getConfiguration();
        }

        this.setState({
          value: value,
          isDismissed: isDismissed,
          isRemoved: isRemoved
        });
      } else {
        this.getConfiguration();
      }

      window.addEventListener('beforeunload', function () {
        if (_this5.state.value) {
          _this5.removeWidget();
        }
      });

      if (!this.state.isDismissed) {
        var boundaries = this.getScrollBoundaries();

        if (!boundaries) {
          return;
        }

        if (boundaries.firstPost < 0 && (!boundaries.hasReplyBox || boundaries.replyBoxTop)) {
          this.setState({
            isSticky: true
          });
        }

        window.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var isSticky = this.state.isSticky;
      var boundaries = this.getScrollBoundaries();
      var newScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (newScroll < this.oldScroll) {
        this.oldScroll = newScroll;
      } else {
        this.setState({
          isSticky: false
        });
        this.oldScroll = newScroll;
        return;
      }

      if (!boundaries) {
        return;
      }

      if (!isSticky && boundaries.firstPost < 0 && (!boundaries.hasReplyBox || boundaries.replyBoxTop)) {
        this.setState({
          isSticky: true
        });
      } else if (isSticky && (boundaries.firstPost > 0 || boundaries.hasReplyBox && boundaries.replyBoxBottom)) {
        this.setState({
          isSticky: false
        });
      }
    }
  }, {
    key: "getScrollBoundaries",
    value: function getScrollBoundaries() {
      var _firstPostElement$get;

      var firstPostElement = document.querySelector('.qa-topic-first-post');
      var firstPost = (_firstPostElement$get = firstPostElement === null || firstPostElement === void 0 ? void 0 : firstPostElement.getBoundingClientRect()) !== null && _firstPostElement$get !== void 0 ? _firstPostElement$get : null;
      var hasReplyBox = document.querySelector('.qa-reply') !== null;
      var replyBoxElement = document.querySelector('.qa-reply');
      var replyBox = hasReplyBox && replyBoxElement ? replyBoxElement.getBoundingClientRect() : null;

      if (!firstPost || !replyBox) {
        return null;
      }

      return {
        firstPost: firstPost.height + firstPost.top,
        replyBoxTop: replyBox.top > window.innerHeight,
        replyBoxBottom: replyBox.top < window.innerHeight,
        hasReplyBox: hasReplyBox
      };
    }
  }, {
    key: "getConfiguration",
    value: function () {
      var _getConfiguration = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.state.configurationLoaded) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return _axios.default.get(_config.CONTENT_HELPFULNESS_SETTINGS_URL, {
                  params: {
                    topicId: this.props.topic.id,
                    topicType: (0, _getTopicType.default)(this.props.topic.prefixId, this.props.topic.contentType)
                  }
                });

              case 4:
                _yield$axios$get = _context2.sent;
                data = _yield$axios$get.data;
                this.setState({
                  visible: data.visible,
                  indicatorEnabled: data.indicatorEnabled,
                  helpfulnessPercentage: data.helpfulnessPercentage,
                  configurationLoaded: true
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getConfiguration() {
        return _getConfiguration.apply(this, arguments);
      }

      return getConfiguration;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateStorage();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          phrases = _this$props.phrases,
          renderWithClasses = _this$props.renderWithClasses;
      var _this$state = this.state,
          animationClass = _this$state.animationClass,
          isRemoved = _this$state.isRemoved,
          value = _this$state.value,
          isDismissed = _this$state.isDismissed,
          isSticky = _this$state.isSticky,
          visible = _this$state.visible,
          indicatorEnabled = _this$state.indicatorEnabled,
          helpfulnessPercentage = _this$state.helpfulnessPercentage;
      var isVoted = value;

      if (isRemoved || isDismissed && isSticky || !visible) {
        return null;
      }

      var topicHelpfulness = (0, _preact.h)(_topicHelpfulness.default, {
        setData: this.setData,
        hideWidget: this.hideWidget,
        isVoted: isVoted,
        isSticky: isSticky,
        phrases: phrases.Forum,
        showIndicator: indicatorEnabled,
        indicatorPercentage: helpfulnessPercentage,
        animationClass: animationClass
      });
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)({
          'qa-topic-helpfulness topic-helpfulness_component-wrapper': renderWithClasses
        })
      }, topicHelpfulness, Boolean(isSticky) && (0, _preact.h)(_preactPortal.default, {
        into: "#comments"
      }, topicHelpfulness));
    }
  }]);
  return TopicHelpfulnessContainer;
}(_preact.Component);

var _default = TopicHelpfulnessContainer;
exports.default = _default;